module.exports = __webpack_public_path__ + "media/images/redesign-images/collegiate-new/header-image-01-73c3b7611705cc0e8dbab86be31bfc8b.webp";